import { useTranslation } from 'libs/i18n';
import { Link } from 'libs/navigation';
import { ParamsType } from 'libs/navigation/types';
import { Tooltip, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

import { TitleStyled } from './Title.styles';

export interface TitleProps<Path extends string> {
  title: string;
  backLink?: Path;
  backLinkParams?: ParamsType<Path> | undefined;
  className?: string;
}

export const Title = <Path extends string>({
  backLinkParams,
  title,
  backLink,
  className,
}: TitleProps<Path>) => {
  const { t } = useTranslation();
  return (
    <TitleStyled className={className}>
      {!!backLink && (
        <Tooltip title={t('common.back')}>
          <span>
            <Link
              className="title-backLink"
              params={backLinkParams}
              to={backLink}
            >
              <Icon.ArrowLeft className="title-backLink-icon" size={34} />
            </Link>
          </span>
        </Tooltip>
      )}
      <Typography as="h1" variant="headline" variantMobile="subtitle">
        {title}
      </Typography>
    </TitleStyled>
  );
};
